import { Component, OnInit, inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { LoanAiService } from '../loanAiService';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-upload-doc',
  templateUrl: './upload-doc.component.html',
  styleUrls: ['./upload-doc.component.scss'],
  imports: [FormsModule, MatFormFieldModule, MatInputModule],
  standalone: true,
})
export class UploadDocComponent implements OnInit {
  private _snackBar = inject(MatSnackBar);
  message = 'Ingestion completed!!';
  requestId = '';


  constructor(
    private service: LoanAiService) {
  }
  ngOnInit(): void {
  }

  onSubmit() {
    this.service.FetchSharepoint().subscribe((data) => {
      console.log(data);
      this.requestId = data.request_id;
      this.callPollApi(this.requestId);

    });

  }

  callPollApi(data: any) {
    setTimeout(() => {
      this.goToPoll(data);
    }, 1000);
  }


  goToPoll(data: any) {
    this.service.pollApi(data).subscribe((data) => {
      console.log(data);

      if (data.status === 'success') {
        this.openSnackBar(this.message);
      }
    })
  }

  openSnackBar(data: any) {
    this._snackBar.open(data);
  }

}
